import { TableHeadersType } from "../tableHeadersConstants/tableHeadersType";

export const TIMESHEETREPORT_HEADERS: TableHeadersType[] = [
  {
    label: "DATE",
    value: "date",
  },
  {
    label: "TYPE",
    value: "type",
  },
  {
    label: "CLIENT & JOB",
    value: "job_name",
  },
  {
    label: "TIME",
    value: "start_time",
  },
  {
    label: "TOTAL HOURS",
    value: "time_difference",
  },
  {
    label: "ACTIVITY CODE",
    value: "activity_code",
  },
  {
    label: "COMMENT",
    value: "comments",
  },
];

export const TIMESHEET_SUMMARY_REPORT_HEADERS: TableHeadersType[] = [
  {
    label: "USER NAME",
    value: "user_name",
  },
  {
    label: "BILLABLE HOURS",
    value: "billable_sum",
  },
  {
    label: "NON-BILLABLE HOURS",
    value: "non_billable_sum",
  },
 
  {
    label: "TOTAL HOURS",
    value: "total_hours_sum",
  },
 
];

export const CLIENT_WISE_USER_TOTAL_HOURS_HEADERS = [
  {
    label: "",
    value: "accordian",
    width: "30px",
  },
  {
    label: "User Name",
    value: "user_name",
  },
  {
    label: "Total Hours",
    value: "total_hours",
  },
  {
    label: "",
    value: "",
  },
];

export const CLIENT_WISE_USER_TOTAL_TIME_AND_DATE_HEADERS = [
  { label: "Date", value: "date", width: "500px" },
  { label: "Hours", value: "hours", width: "500px" },
];

export const TIMESHEET_CLIENT_WISE_MONTHLY_REPORT_HEADERS: TableHeadersType[] = [
  {
    label: "MONTH",
    value: "month",
  },
  {
    label: "TOTAL HOURS CHARGED",
    value: "total_hours_charged",
  },
 
 
];
export const TIMESHEET_MONTHLY_REPORT_HEADERS: TableHeadersType[] = [
  {
    label: "CLIENT NAME",
    value: "name",
  },
  {
    label: "TOTAL HOURS CHARGED",
    value: "total_hours_charged",
  },

 
 
];